export default __webpack_public_path__ + "static/media/ic-info-black.612a765c.svg";